var map = {
	"./bg_2.png": "e81f",
	"./bg_3.png": "432f",
	"./bg_4.png": "2b7e",
	"./bg_5.png": "bd2c",
	"./bg_dark.png": "77be",
	"./bg_default.png": "d1f5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fd6c";